import { schema, normalize } from 'normalizr';
import { MenteeInfo } from 'course_supervisor_dashboard/components/types';
import { VideoPracticeSubmission } from '../models/video-practice';
import { BasicMentee } from '../models/course';

const videoPracticeSubmissionSchema = new schema.Entity<VideoPracticeSubmission>('videoPracticeSubmissions', {}, {
  idAttribute: 'id',
});

const videoPracticeSubmissionsArraySchema = [videoPracticeSubmissionSchema];

const supervisorCoursesSchema = new schema.Entity<BasicMentee>(
  'courses',
  {},
  {
    idAttribute: 'id',
  },
);

const supervisorCoursesArraySchema = [supervisorCoursesSchema];

const supervisorCoursesNormalizedData = (response: MenteeInfo[]) => normalize<
MenteeInfo,
{ courses: { [key: string]: MenteeInfo } }
>(response, supervisorCoursesArraySchema);

export { videoPracticeSubmissionsArraySchema, supervisorCoursesNormalizedData };
